
import { getRequest, postRequest,monitorGateway} from "@/utils/request";
import qs from "qs";
window.qs = qs;
// 综合监控 electricity
export const monitorApi = {
  // 容量
  queryCapacity: () => {
    return getRequest(`${monitorGateway}/monitors/gc`);
  },
  // 类型
  queryType: () => {
    return getRequest(`${monitorGateway}/monitors/type`);
  },
  // 总用电量实时情况统计
  queryTotalElectricity: () => {
    return getRequest(`${monitorGateway}/monitors/hour/power`);
  },
  // 用电量统计
  queryElectricity: () => {
    return getRequest(`${monitorGateway}/monitors/month/power`);
  },
    // 当月累计碳排情况统计
    queryCarbonEmission: (params) => {
      return getRequest(`${monitorGateway}/monitors/month/co2`,params);
    },
      // 当月能耗分析情况统计
  queryEnergyConsumption: (params) => {
    return getRequest(`${monitorGateway}/monitors/month/equipment`,params);
  },
  queryMonthlyAnalysis: (params) => {
    return getRequest(`${monitorGateway}/monitor/monthly/common`,params);
  },
  // 当月用电量情况统计
  queryMonthlyElectricity: (params) => {
    return getRequest(`${monitorGateway}/monitor/monthly/statistics`,params);
  },
    // 当月用电量情况统计
    queryProductionEnergy: (params) => {
      return getRequest(`${monitorGateway}/monitor/ranking`,params);
    },
        // 碳排情况统计
        queryTotalCarbon: () => {
          return getRequest(`${monitorGateway}/monitors/hour/co2`);
        },
        // 碳排情况统计
        yearMonthDay: (params) => {
          return getRequest(`${monitorGateway}/monitor/year/month/day`,params);
        },
        //调取后端解析用户信息接口(前端无需解析处理)
        sso: (params) => {
          return getRequest(`/power-system/sso/initUserRole`,params);
        },
      };
